<template>
    <img
        class="w-auto"
        :src="serviceProvider?.logo_url || '/smartrecycle_logo.png'"
        alt="Logo">
</template>

<script setup>
import {useAuthStore} from '~/store/auth'

const authStore = useAuthStore()

const serviceProvider = computed(() => {
    return authStore.serviceProvider
})
</script>